import { motion } from 'framer-motion';
import { FaCheck } from 'react-icons/fa';
import { images } from '../../utils/images';

const Platform = () => {
  const features = [
    "Very negligible entry cost up cost ( 0.044 BNB )",
    "100% instant disbusal of rewards & profits",
    "Earn upto 350 000 BNB",
    "No team building compulsory",
    "Huge passive income/profits"
  ];

  return (
    <div className="bg-dark py-20">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="relative h-[400px] rounded-lg overflow-hidden shadow-xl"
          >
            <img 
              src={images.platform} 
              alt="Platform features" 
              className="absolute inset-0 w-full h-full object-cover"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl font-bold text-white mb-6">
              Distinctive features of our platform
            </h2>
            <p className="text-gray-300 mb-8">
              At Mo<span className="text-primary">bnb</span>, we are committed to providing unparalleled business opportunities that help our users grow and secure their future. Our innovative helping platform connects individuals with a community of investors.
            </p>
            <ul className="space-y-4">
              {features.map((feature, index) => (
                <li key={index} className="flex items-center text-gray-300">
                  <FaCheck className="text-primary mr-3" />
                  {feature}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Platform;